import { connect } from 'react-redux'
import { compose, withHandlers } from 'recompose'
import withClientGeoLocation from 'components/common/hoc/withClientGeoLocation'
import { submitSearchStoreFormAction } from 'actions/storeLocator'
import { getSearchByAddressParams } from 'helpers/storeLocator'
import SavedLocationEmpty from './SavedLocationEmpty'

const withSavedLocationEmptyHandlers = withHandlers({
  findStoreHandleSubmit: ({ coords, submitSearchStoreFormAction }) => (values = {}) =>
    submitSearchStoreFormAction({ ...values, params: getSearchByAddressParams(coords) })
})

export default compose(
  connect(null, { submitSearchStoreFormAction }),
  withClientGeoLocation,
  withSavedLocationEmptyHandlers
)(SavedLocationEmpty)
